module.exports = __webpack_public_path__ + "img/x.7fd8268c.svg";